import { useEffect, useRef, useState } from 'react';
import { Row, Col, Card, Modal, Button } from 'react-bootstrap';
import AppNavbar from '../Navbar/AppNavbar';
import '../../assets/css/dashboard.scss';
import { Tabs, Tab } from 'react-bootstrap';
import RecentActivities from './RecentActivities';
import RecentSearchTable from './RecentSearchTable';
import Footer from '../Navbar/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { loadApCreditData, loadGetSubscription, loadGetSubscriptionByPlan, loadGetSubscriptionGraph, loadloginDetails, loadRecentSearch, loadRecentUsers, loadSessionLogins, loadTotalCounts, loadUserActivityData, loadUserDownloadData } from '../redux/action';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
    Alert,
    Box,
    Chip,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
} from "@mui/material";
import {
    Users, CreditCard, Layers, DollarSign, History,
    ArrowUpRight, ArrowDownRight
} from 'lucide-react';

import {
    ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip,
    Legend
} from 'recharts';
import DonutChart from './DonutChart';
import { capitalizeFirstLetter, getInitials } from '../CommonFile/Function_utils';
import moment from 'moment';
import { get_total_couts } from '../CommonFile/DropdownValues';
import APCreditData from './APCreditData';
import RecentActivityCard from '../ActivityLogs/RecentActivityCard';
import { loadRecentActivities } from '../redux/activityService/act_action';

const ORDS_URL =
    "https://g4771f79f8f4279-leadmerge.adb.ap-hyderabad-1.oraclecloudapps.com/ords/leadmerge/dashboard/get_provider_error_log";

const Dashboard = () => {
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));

    const { subscribed_user, subscriber_graph_data, subscriber_by_plan,
        recent_users, session_logins, apollo_credit_data
    } = useSelector(state => state.data);

    const { recent_activity_data } = useSelector(state => state.activitydata);

    const [lineData, setLineData] = useState([]);
    const [duration, setDuration] = useState('monthly');

    const [dataStatus, setDataStatus] = useState({
        sbnStatus: false,
        uersStatus: false,
        sbnGraphStatus: false,
        sbnPlanStatus: false,
        activityStatus: false,
        loginsStatus: false,
        apolloCreditsStatus: false,
        downloadsStatus: false,
        searchStatus: false,
    })

    // Provider error log
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const loadErrors = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await fetch(ORDS_URL, {
                headers: { Accept: "application/json" },
            });

            if (!response.ok) {
                throw new Error(`Request failed: HTTP ${response.status}`);
            }

            const data = await response.json();

            const rows = Array.isArray(data)
                ? data
                : data.items ?? [];

            setErrors(rows);
        } catch (err) {
            setError(err.message || "Unable to load provider errors");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadErrors();

        // Refresh the dashboard every 30 seconds.
        const timer = setInterval(loadErrors, 30000);

        return () => clearInterval(timer);
    }, []);

    const unresolvedCount = errors.filter(
        (item) =>
            String(item.RESOLVED ?? item.resolved ?? "N").toUpperCase() !== "Y"
    ).length;

    // provider error log end region 

    // Provider Status 


    const PROVIDER_STATUS_URL =
        "https://g4771f79f8f4279-leadmerge.adb.ap-hyderabad-1.oraclecloudapps.com/ords/leadmerge/dashboard/get_provider_status";

    const [providerStatuses, setProviderStatuses] = useState([]);
    const [providerStatusLoading, setProviderStatusLoading] = useState(false);
    const [providerStatusError, setProviderStatusError] = useState("");

    const loadProviderStatuses = async () => {
        setProviderStatusLoading(true);
        setProviderStatusError("");

        try {
            const response = await fetch(PROVIDER_STATUS_URL, {
                headers: { Accept: "application/json" },
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const data = await response.json();

            const rows = Array.isArray(data)
                ? data
                : data.items ?? [];

            setProviderStatuses(rows);
        } catch (err) {
            setProviderStatusError(
                err.message || "Unable to load provider status"
            );
        } finally {
            setProviderStatusLoading(false);
        }
    };

    useEffect(() => {
        loadProviderStatuses();

        const timer = setInterval(loadProviderStatuses, 30000);

        return () => clearInterval(timer);
    }, []);



    const transformGraphData = (apiResponse) => {
        if (!apiResponse || !apiResponse.labels) return [];

        const { labels, series } = apiResponse;

        const freeData = series.find(s => s.name === 'Free')?.data || [];
        const basicData = series.find(s => s.name === 'Basic')?.data || [];
        const profData = series.find(s => s.name === 'Professional')?.data || [];
        const enterpriseData = series.find(s => s.name === 'Enterprise')?.data || [];

        return labels.map((label, index) => ({
            name: label,
            free: freeData[index] || 0,
            basic: basicData[index] || 0,
            professional: profData[index] || 0,
            enterprise: enterpriseData[index] || 0
        }));
    };

    useEffect(() => {
        if (Object.keys(subscriber_graph_data).length > 0) {
            const formatted = transformGraphData(subscriber_graph_data);
            setLineData(formatted);
        }
    }, [subscriber_graph_data]);



    const planStatus = sessionStorage.getItem("plan_expired");

    const navigate = useNavigate();
    const user_role = signInDetails[0]?.role.toLowerCase();

    const [key, setKey] = useState("viewed");
    const [pageStatus, setPageStatus] = useState(false);
    const [show, setShow] = useState(false);

    const dispatch = useDispatch();
    const hasRun = useRef(false);

    useEffect(() => {
        if (planStatus) {
            setShow(true);
        }
    }, [planStatus])


    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        dispatch(loadloginDetails());

        if (signInDetails[0]?.role === "super_admin") {
            dispatch(loadGetSubscription()).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, sbnStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, sbnStatus: true }))
                });
            dispatch(loadRecentUsers()).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, uersStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, uersStatus: true }))
                });
            dispatch(loadGetSubscriptionByPlan()).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, sbnPlanStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, sbnPlanStatus: true }))
                });
            const params = {
                page: 1,
                page_size: 10,
                activity_type: "",
                search_text: "",
                start_date: null,
                end_date: null,
            }
            dispatch(loadRecentActivities(params)).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, activityStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, activityStatus: true }))
                });
            dispatch(loadSessionLogins()).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, loginsStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, loginsStatus: true }))
                });
            dispatch(loadApCreditData()).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, apolloCreditsStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, apolloCreditsStatus: true }))
                });
        } else {
            dispatch(loadTotalCounts());
            // dispatch(loadSubscriptions());

            // dispatch(getAllUploads(1, 20, signInDetails[0]?.role, signInDetails[0]?.sbn_id, signInDetails[0]?.id, []));
            dispatch(loadUserActivityData());
            dispatch(loadUserDownloadData());
            dispatch(loadRecentSearch());
            // dispatch(loadCountryGraph());
            // dispatch(loadCountryGraph("map"));
            // dispatch(loadIndustryGraph());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (signInDetails[0]?.role === "super_admin") {
            dispatch(loadGetSubscriptionGraph(duration)).then((resp) => {
                setDataStatus((prev) =>
                    ({ ...prev, sbnGraphStatus: true }))
            })
                .catch((err) => {
                    setDataStatus((prev) =>
                        ({ ...prev, sbnGraphStatus: true }))
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duration])

    // function decodeResetToken(token, secretKey = 'lm_pswd_key_226') {
    //     try {
    //         // 1. Base64 decode to binary string
    //         const decodedBinary = atob(token);

    //         // 2. XOR decrypt into a Uint8Array
    //         const decryptedBytes = new Uint8Array(decodedBinary.length);
    //         for (let i = 0; i < decodedBinary.length; i++) {
    //             const keyChar = secretKey.charCodeAt(i % secretKey.length);
    //             decryptedBytes[i] = decodedBinary.charCodeAt(i) ^ keyChar;
    //         }

    //         // 3. Decode UTF-8 bytes to string
    //         const decoder = new TextDecoder('utf-8');
    //         const decrypted = decoder.decode(decryptedBytes);

    //         // 4. Expect format: email|YYYYMMDDHHMMSS
    //         const [email, timestamp] = decrypted.split('|');

    //         if (!email || !timestamp || timestamp.length !== 14) {
    //             throw new Error("Invalid format");
    //         }

    //         // 5. Parse timestamp
    //         const year = parseInt(timestamp.slice(0, 4));
    //         const month = parseInt(timestamp.slice(4, 6)) - 1;
    //         const day = parseInt(timestamp.slice(6, 8));
    //         const hour = parseInt(timestamp.slice(8, 10));
    //         const minute = parseInt(timestamp.slice(10, 12));
    //         const second = parseInt(timestamp.slice(12, 14));

    //         const expiryDate = new Date(year, month, day, hour, minute, second);
    //         const now = new Date();

    //         return {
    //             email,
    //             expiryDate,
    //             isExpired: now > expiryDate
    //         };
    //     } catch (error) {
    //         return {
    //             error: 'Invalid or corrupted token',
    //             details: error.message
    //         };
    //     }
    // }

    const setKeyStatus = (key) => {
        setPageStatus(false);
        setKey(key)
    }

    const onHide = () => {
        setShow(false);
    }

    const closeModal = () => {
        setShow(false);
    }

    const navigateToUpgrade = () => {
        onHide();
        navigate('/upgrade_plan')
    }

    const [totalPlanCount, setTotalPlanCount] = useState(0)
    useEffect(() => {
        if (subscriber_by_plan.length > 0) {
            let totalCount = 0;
            subscriber_by_plan.forEach(item => {
                totalCount += item.count;
            })

            setTotalPlanCount(totalCount)
        }
    }, [subscriber_by_plan])
    // endregion

    // #region navigate function
    const navigateToPage = (card_type) => {
        if (card_type === "total") {
            navigate('/subscriptions', {
                state: {
                    get_status: card_type,
                }
            })
        } else if (card_type === "activity") {
            navigate("/user_activity");
        } else if (card_type === "payment") {
            navigate("/payment_history");
        } else if (card_type === "Inactive") {
            navigate("/subscriptions", {
                state: {
                    active_status: card_type,
                },
            });
        } else {
            navigate("/subscriptions", {
                state: {
                    sbn_type: card_type,
                },
            });
        }
    }
    // #endregion

    return (
        <div className='page-layout'>
            <AppNavbar />
            <div className='page-content' style={{ overflow: "auto" }}>

                {user_role === "super_admin" ? <div className="dashboard-body">
                    <div className="dashboard-title-row">
                        <div>
                            <div className='wel-come-text'>Welcome {capitalizeFirstLetter(signInDetails[0].name)} 💐</div>
                            <div className='wel-come-subtext'>🔍 Welcome back, Here's what's happening with LeadMerge. Get a complete overview of your platform with real-time analytics, user activity, and subscription trends.</div>
                        </div>
                    </div>

                    {/* Metric Cards Grid */}
                    <section className="metrics-grid">
                        {!dataStatus.sbnStatus ? <Skeleton className='custom-skeleton' sx={{ height: "130px" }} />
                            : <div className="metric-card" onClick={() => navigateToPage("total")}>
                                <div className="metric-header">
                                    <div className="icon-wrapper blue"><Users size={20} /></div>
                                    <div>
                                        <span className="metric-label">Total Subscriptions</span>
                                        <h3>{subscribed_user?.totalUsers?.count}</h3>
                                    </div>
                                </div>
                                {(subscribed_user?.totalUsers?.comparison && subscribed_user?.totalUsers?.comparison >= 0) ?
                                    <span className="trend positive"><ArrowUpRight size={14} /> {subscribed_user?.totalUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                    :
                                    <span className="trend negative"><ArrowDownRight size={14} /> {subscribed_user?.totalUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                }
                            </div>}
                        {!dataStatus.sbnStatus ? <Skeleton className='custom-skeleton' sx={{ height: "130px" }} />
                            :
                            <div className="metric-card" onClick={() => navigateToPage("basic")}>
                                <div className="metric-header">
                                    <div className="icon-wrapper green"><CreditCard size={20} /></div>
                                    <div>
                                        <span className="metric-label">Paid Subscriptions</span>
                                        <h3>{subscribed_user?.activeUsers?.count}</h3>
                                    </div>
                                </div>
                                {(subscribed_user?.activeUsers?.comparison && subscribed_user?.activeUsers?.comparison >= 0) ?
                                    <span className="trend positive"><ArrowUpRight size={14} /> {subscribed_user?.activeUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                    :
                                    <span className="trend negative"><ArrowDownRight size={14} /> {subscribed_user?.activeUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                }
                            </div>}

                        {!dataStatus.sbnStatus ? <Skeleton className='custom-skeleton' sx={{ height: "130px" }} />
                            :
                            <div className="metric-card" onClick={() => navigateToPage("free")}>
                                <div className="metric-header">
                                    <div className="icon-wrapper orange"><History size={20} /></div>
                                    <div>
                                        <span className="metric-label">Trial Subscriptions</span>
                                        <h3>{subscribed_user?.freeUsers?.count}</h3>
                                    </div>
                                </div>
                                {(subscribed_user?.freeUsers?.comparison && subscribed_user?.freeUsers?.comparison >= 0) ?
                                    <span className="trend positive"><ArrowUpRight size={14} /> {subscribed_user?.freeUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                    :
                                    <span className="trend negative"><ArrowDownRight size={14} /> {subscribed_user?.freeUsers?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                }
                            </div>}

                        {!dataStatus.sbnStatus ? <Skeleton className='custom-skeleton' sx={{ height: "130px" }} />
                            :
                            <div className="metric-card" onClick={() => navigateToPage("payment")}>
                                <div className="metric-header">
                                    <div className="icon-wrapper dark-blue"><DollarSign size={20} /></div>
                                    <div>
                                        <span className="metric-label">MRR (This Month)</span>
                                        <h3>${subscribed_user?.totalRevenue?.amount}</h3>
                                    </div>
                                </div>
                                {(subscribed_user?.mrr?.comparison && subscribed_user?.mrr?.comparison >= 0) ?
                                    <span className="trend positive"><ArrowUpRight size={14} /> {subscribed_user?.mrr?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                    :
                                    <span className="trend negative"><ArrowDownRight size={14} /> {subscribed_user?.mrr?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                }
                            </div>}

                        {!dataStatus.sbnStatus ? <Skeleton className='custom-skeleton' sx={{ height: "130px" }} />
                            :
                            <div className="metric-card" onClick={() => navigateToPage("Inactive")}>
                                <div className="metric-header">
                                    <div className="icon-wrapper red"><Layers size={20} /></div>
                                    <div>
                                        <span className="metric-label">Expired/Deleted Subscriptions</span>
                                        <h3>{subscribed_user?.expiredSubscriptions?.count}</h3>
                                    </div>
                                </div>
                                {(subscribed_user?.expiredSubscriptions?.comparison && subscribed_user?.expiredSubscriptions?.comparison >= 0) ?
                                    <span className="trend positive"><ArrowUpRight size={14} /> {subscribed_user?.expiredSubscriptions?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                    :
                                    <span className="trend negative"><ArrowDownRight size={14} /> {subscribed_user?.expiredSubscriptions?.comparison}% <span className="trend-lbl">vs last 7 days</span></span>
                                }
                            </div>}
                    </section>
                    <section className="data-visualization-row">

                        <div className="activity-card credit-details-card">
                            <div className="card-header-row">
                                <h3>Apollo Account</h3>
                            </div>
                            {!dataStatus.apolloCreditsStatus ? <Skeleton className='custom-skeleton' sx={{ height: "400px" }} />
                                :
                                <>{Object.keys(apollo_credit_data).length > 0 && <APCreditData />}</>}
                        </div>

                        {/* 1. Subscriptions Overview Line Chart */}
                        <div className="chart-card overview-chart">
                            <div className="chart-header">
                                <h3>Subscriptions Overview</h3>
                                <select
                                    value={duration}
                                    onChange={(e) => setDuration(e.target.value)}
                                    className="dropdown-inline bg-slate-900 border text-sm cursor-pointer durtion_dropdown"
                                >
                                    <option value="weekly">Last 7 Days</option>
                                    <option value="monthly">Last 30 Days</option>
                                    <option value="3months">Last 3 Months</option>
                                    <option value="6months">Last 6 Months</option>
                                    <option value="year">Past Year</option>
                                </select>
                            </div>

                            <div className="chart-wrapper line-chart-wrapper">
                                {!dataStatus.sbnGraphStatus ? <Skeleton className='custom-skeleton' sx={{ height: "400px" }} />
                                    :
                                    <ResponsiveContainer width="100%" height={400}>
                                        <LineChart data={lineData} margin={{ top: 15, right: 20, left: -20, bottom: 5 }}>
                                            <XAxis
                                                dataKey="name"
                                                axisLine={false}
                                                tickLine={false}
                                                tick={{ fill: '#64748b', fontSize: 12 }}
                                            />
                                            <YAxis
                                                axisLine={false}
                                                tickLine={false}
                                                tick={{ fill: '#64748b', fontSize: 12 }}
                                                domain={[0, 'auto']}
                                                tickFormatter={(val) => (val === 0 ? '0' : val)}
                                            />
                                            <Tooltip
                                                contentStyle={{
                                                    background: '#0f172a',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    color: '#fff',
                                                    fontSize: '13px'
                                                }}
                                            />
                                            <Legend
                                                wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }}
                                                iconType="circle"
                                            />

                                            {/* 1. Free Line (Gray Accent) */}
                                            <Line
                                                type="monotone"
                                                dataKey="free"
                                                name="Free Tier"
                                                stroke="#94a3b8"
                                                strokeWidth={2}
                                                dot={{ r: 3, fill: '#94a3b8' }}
                                                activeDot={{ r: 5 }}
                                            />

                                            {/* 2. Basic Line (Sky Blue Accent) */}
                                            <Line
                                                type="monotone"
                                                dataKey="basic"
                                                name="Basic Plan"
                                                stroke="#f59e0b"
                                                strokeWidth={2}
                                                dot={{ r: 3, fill: '#f59e0b' }}
                                            />

                                            {/* 3. Professional Line (Indigo Accent) */}
                                            <Line
                                                type="monotone"
                                                dataKey="professional"
                                                name="Professional"
                                                stroke="#3b82f6"
                                                strokeWidth={2.5}
                                                dot={{ r: 4, fill: '#3b82f6' }}
                                            />

                                            {/* 4. Enterprise Line (Emerald Green Accent) */}
                                            <Line
                                                type="monotone"
                                                dataKey="enterprise"
                                                name="Enterprise"
                                                stroke="#4f46e5"
                                                strokeWidth={2.5}
                                                dot={{ r: 4, fill: '#4f46e5' }}
                                            />
                                        </LineChart>
                                    </ResponsiveContainer>
                                }
                            </div>
                        </div>
                        <div className="activity-card">
                            <div className="card-header-row">
                                <h3>Recent Activity</h3>
                                <span onClick={() => navigateToPage("activity")} className="view-all-link m-0" >View all activity →</span>
                            </div>
                            {!dataStatus.activityStatus ? <Skeleton className='custom-skeleton' sx={{ height: "400px" }} />
                                :
                                <RecentActivityCard displayData={recent_activity_data} />}
                        </div>

                    </section>

                    {/* Tables & Activity Lists */}
                    <section className="details-row">
                        <div className="data-table-card">
                            <div className="card-header-row">
                                <h3>Recent Users</h3>
                                <span onClick={() => navigateToPage("total")} className="view-all-link">View all users →</span>
                            </div>
                            <hr className='m-0 mb-3' />
                            {!dataStatus.uersStatus ? <Skeleton className='custom-skeleton' sx={{ height: "500px" }} />
                                :
                                <div className="table-container">
                                    <table className="custom-table">
                                        <thead>
                                            <tr>
                                                <th>User</th>
                                                <th>Email</th>
                                                <th>Plan</th>
                                                <th>Status</th>
                                                <th>Joined On</th>
                                                <th>Upgraded On</th>
                                                {/* <th></th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recent_users.length > 0 && recent_users.map((item, index) => {
                                                let plan = "";
                                                if (item.plan_name && item.plan_name.toLowerCase() === "free") {
                                                    plan = "Trial"
                                                } else {
                                                    plan = "Active"
                                                }

                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="table-user">
                                                                <div className="profile-avatar-table">
                                                                    {item.customer_name && getInitials(item.customer_name.trim())}
                                                                </div>
                                                                <span>{item.customer_name}</span>
                                                            </div>
                                                        </td>
                                                        <td>{item.customer_email}</td>
                                                        <td><span className="badge-plan pro">{capitalizeFirstLetter(item.plan_name)}</span></td>
                                                        <td><span className={`status-dot active_${item.plan_name.toLowerCase()}`}>{plan}</span></td>
                                                        <td>{moment(item.signup_date).format("MMM DD, YYYY")}</td>
                                                        <td>{item.plan_name.toLowerCase() === "free" ? <span className='trail-text'>Trail Subscription</span> : moment(item.renewal_start_date).format("MMM DD, YYYY")}</td>
                                                        {/* <td><MoreVertical size={16} className="actions-icon" /></td> */}
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                        </div>

                        {/* 2. Subscriptions by Plan Donut Chart */}
                        <div className="chart-card distribution-chart">
                            <div className="card-header-row">
                                <h3>Subscriptions by Plan</h3>
                            </div>
                            <hr className='m-0 mb-3' />
                            {!dataStatus.sbnPlanStatus ? <Skeleton className='custom-skeleton' sx={{ height: "500px" }} />
                                :
                                <div className="donut-chart-container">
                                    <div className="donut-graphic-wrapper" style={{ width: '100%' }}>
                                        <DonutChart />

                                        <div className="donut-center-label">
                                            <span className="donut-total">{totalPlanCount}</span>&nbsp;&nbsp;
                                            <span className="donut-lbl">Total</span>
                                        </div>
                                    </div>

                                    <ul className="donut-legends">
                                        {subscriber_by_plan.map((item, idx) => (
                                            <li key={idx}>
                                                <span className={`dot dot_${item.plan}`} ></span>
                                                {item.plan}
                                                <span className="val">{item.count.toLocaleString()} ({item.percentage}%)</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>}
                            {/* <a href="#all-plans" className="view-all-link">View all plans →</a> */}
                        </div>

                        <div className="activity-card">
                            <div className="card-header-row">
                                <div className='text-left'>
                                    <h3>Login Activity</h3>
                                    <p className="card-subtitle">
                                        Overview of users who have logged in today.
                                    </p>
                                </div>
                            </div>
                            <hr className='m-0 mb-3' />
                            {!dataStatus.loginsStatus ? <Skeleton className='custom-skeleton' sx={{ height: "480px" }} />
                                :
                                <div className="activity-timeline">
                                    {session_logins.length > 0 ? (
                                        session_logins.map((item, index) => (
                                            <div className="activity-item" key={index}>
                                                <div className="profile-avatar-table">
                                                    {item.user_name && getInitials(item.user_name.trim())}
                                                </div>

                                                <div className="activity-details">
                                                    <div>
                                                        <p className="activity-text m-0">
                                                            <strong>{item.user_name}</strong>
                                                            <br />
                                                            {item.user_email}
                                                        </p>

                                                        <p className="duration-text m-0">
                                                            <em>Duration: {item.duration}</em>
                                                        </p>

                                                        <div className="activity-footer">
                                                            <span className="activity-time">
                                                                <i className="bx bx-time-five"></i>
                                                                {moment(item.login_time).format("hh:mm A")}
                                                            </span>

                                                            {item.status === "Offline" && (
                                                                <span className="activity-time">
                                                                    <i className="bx bx-time-five"></i>
                                                                    {moment(item.logout_time).format("hh:mm A")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <span className={`activity-status ${item.status}`}>
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="empty-activity-state">
                                            <div className="empty-icon">
                                                <i className="bx bx-user-x"></i>
                                            </div>

                                            <h5>No Login Activity Found</h5>

                                            <p>
                                                There are no user login sessions available for today.
                                            </p>
                                        </div>
                                    )}

                                </div>}
                        </div>
                    </section>

                    {/* Provider Status Module */}

                    <Card className="mt-4">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Provider Health Monitoring</h5>

                            <Button
                                size="sm"
                                variant="outline-primary"
                                onClick={loadProviderStatuses}
                                disabled={providerStatusLoading}
                            >
                                {providerStatusLoading ? "Refreshing..." : "Refresh"}
                            </Button>
                        </Card.Header>

                        <Card.Body>
                            {providerStatusError && (
                                <Alert variant="danger">
                                    Failed to load provider status: {providerStatusError}
                                </Alert>
                            )}

                            <Row>
                                {providerStatuses.map((provider) => {
                                    const name =
                                        provider.PROVIDER_NAME ?? provider.provider_name ?? "Unknown";

                                    const status = String(
                                        provider.STATUS ?? provider.status ?? "UNKNOWN"
                                    ).toUpperCase();

                                    const statusColor =
                                        status === "HEALTHY"
                                            ? "success"
                                            : status === "ERROR" || status === "UNHEALTHY"
                                                ? "danger"
                                                : "secondary";

                                    return (
                                        <Col md={6} sm={6} xs={12} key={provider.ID ?? name} className="mb-3">
                                            <Card className="h-100">
                                                <Card.Body>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="mb-0">{name}</h6>
                                                        <Chip
                                                            label={status}
                                                            color={
                                                                statusColor === "success"
                                                                    ? "success"
                                                                    : statusColor === "danger"
                                                                        ? "error"
                                                                        : "default"
                                                            }
                                                            size="small"
                                                        />
                                                    </div>

                                                    <div>Last HTTP status: {
                                                        provider.LAST_STATUS_CODE ??
                                                        provider.last_status_code ??
                                                        "N/A"
                                                    }</div>

                                                    <div>Successful calls: {
                                                        provider.SUCCESS_COUNT ??
                                                        provider.success_count ??
                                                        0
                                                    }</div>

                                                    <div>Failed calls: {
                                                        provider.FAILURE_COUNT ??
                                                        provider.failure_count ??
                                                        0
                                                    }</div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })}
                            </Row>

                            {!providerStatusLoading && providerStatuses.length === 0 &&
                                !providerStatusError && (
                                    <Alert variant="info">
                                        No provider status records found.
                                    </Alert>
                                )}
                        </Card.Body>
                    </Card> 
                    {/* end provider status region */}

                    {/* Provider Error Monitoring */}
                    {/* <Card className="mt-4">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Provider Error Monitoring</h5>

                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={loadErrors}
                                disabled={loading}
                            >
                                {loading ? "Refreshing..." : "Refresh"}
                            </Button>
                        </Card.Header>

                        <Card.Body>
                            {error && (
                                <Alert severity="error" className="mb-3">
                                    {error}
                                </Alert>
                            )}

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Card body>
                                        <div>Total Provider Errors</div>
                                        <h3>{errors.length}</h3>
                                    </Card>
                                </Col>

                                <Col md={6}>
                                    <Card body>
                                        <div>Unresolved Errors</div>
                                        <h3 className="text-danger">{unresolvedCount}</h3>
                                    </Card>
                                </Col>
                            </Row>

                            {loading && errors.length === 0 ? (
                                <div className="text-center p-4">
                                    <CircularProgress />
                                </div>
                            ) : errors.length === 0 ? (
                                <Alert severity="info">
                                    No provider errors found.
                                </Alert>
                            ) : (
                                <TableContainer component={Paper}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                               
                                                <TableCell>Provider</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Error Type</TableCell>
                                                <TableCell>Error Message</TableCell>
                                                <TableCell>Endpoint</TableCell>
                                                <TableCell>Created At</TableCell>
                                                <TableCell>Email (Y/N)</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {errors.map((item, index) => (
                                                <TableRow key={item.ID ?? item.id ?? index}>
                                                  

                                                    <TableCell>
                                                        {item.PROVIDER_NAME ??
                                                            item.provider_name ?? "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        <Chip
                                                            label={
                                                                item.STATUS_CODE ??
                                                                item.status_code ?? "-"
                                                            }
                                                            color="error"
                                                            size="small"
                                                        />
                                                    </TableCell>

                                                    <TableCell>
                                                        {item.ERROR_TYPE ??
                                                            item.error_type ?? "-"}
                                                    </TableCell>

                                                    <TableCell
                                                        sx={{
                                                            maxWidth: 300,
                                                            overflowWrap: "anywhere"
                                                        }}
                                                    >
                                                        {item.ERROR_MESSAGE ??
                                                            item.error_message ?? "-"}
                                                    </TableCell>

                                                    <TableCell
                                                        sx={{
                                                            maxWidth: 250,
                                                            overflowWrap: "anywhere"
                                                        }}
                                                    >
                                                        {item.ENDPOINT ??
                                                            item.endpoint ?? "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        {item.CREATED_AT ??
                                                            item.created_at ?? "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        {item.EMAIL_SENT ??
                                                            item.email_sent ?? "-"}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Card.Body>
                    </Card> */}
                    {/* end provider error log region */}

                </div>
                    :
                    <div className='dashboard-container'>
                        <div className='wel-come-text'>Welcome {capitalizeFirstLetter(signInDetails[0].name)} 💐</div>
                        <div className='wel-come-subtext'>🔍 LeadMerge, your trusted platform for prospecting, lead generation, and business growth.</div>
                        <Row className='p-3 m-0'>
                            {get_total_couts.length !== 0 ?
                                <>
                                    {get_total_couts.map((item, index) => {
                                        const Icon = item.icon;

                                        const colors = [
                                            { bg: "#EEF2FF", color: "#4F46E5" }, // Indigo
                                            { bg: "#ECFDF5", color: "#10B981" }, // Green
                                            { bg: "#FFF7ED", color: "#F97316" }, // Orange
                                            { bg: "#FEF2F2", color: "#EF4444" }, // Red
                                            { bg: "#EFF6FF", color: "#2563EB" }, // Blue
                                        ];

                                        const theme = colors[index % colors.length];

                                        return (
                                            <Col key={index}>
                                                <Card className="p-3 dashboard-count-card">
                                                    <div>
                                                        <small className="text-muted count-header">
                                                            {item.title}
                                                        </small>

                                                        <h5 className="fw-bold mb-0">{item.count}</h5>

                                                        <small className="count-subtitle">
                                                            {item.description}
                                                        </small>
                                                    </div>

                                                    <div
                                                        className="dashboard-card-icon"
                                                        style={{
                                                            backgroundColor: theme.bg,
                                                            color: theme.color,
                                                        }}
                                                    >
                                                        <Icon size={28} />
                                                    </div>
                                                </Card>
                                            </Col>
                                        );
                                    })}
                                </>
                                :
                                <>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <Col key={index} style={{ height: "100px" }}>
                                            <Skeleton className="custom_skeleton" />
                                        </Col>
                                    ))}</>
                            }

                        </Row>
                        <Row className='p-3 donut-chart-row'>

                            <Col md={6} className='recent-search-table-col'>
                                <RecentSearchTable />
                            </Col>
                            <Col md={6} className='dashboard-subscription-container'>
                                <Card className='dashboard-subscription-card'>
                                    <div className='dashboard-subscription-card-header'>
                                        <div className='card-header-div'>
                                            <h5>Recent Activities</h5>
                                            <small>
                                                Track recent downloads, and user sessions
                                            </small>
                                        </div>
                                    </div>
                                    <Card.Body>
                                        <Tabs defaultActiveKey={user_role === "super_admin" ? "sessions" : "viewed"}
                                            id="recent-activities-tabs" className="activity-tabs"
                                            activeKey={key}
                                            onSelect={(k) => setKeyStatus(k)}>
                                            <Tab eventKey="viewed" title={
                                                <span>
                                                    <i className='bx bx-detail'></i>
                                                    Recent Views
                                                </span>
                                            }>
                                                {key === "viewed" && <RecentActivities pageStatus={pageStatus} setPageStatus={setPageStatus} type="viewed" />}
                                            </Tab>
                                            <Tab eventKey="lists" title={
                                                <span>
                                                    <i className='bx bx-list-ul'></i>
                                                    Lists
                                                </span>
                                            }>
                                                {key === "lists" && <RecentActivities pageStatus={pageStatus} setPageStatus={setPageStatus} type="lists" />}
                                            </Tab>
                                            <Tab eventKey="downloads" title={
                                                <span>
                                                    <i className='bx bx-download'></i>
                                                    Downloads
                                                </span>
                                            }>
                                                {key === "downloads" && <RecentActivities pageStatus={pageStatus} setPageStatus={setPageStatus} type="downloads" />}
                                            </Tab>


                                            {/* {user_role === "super_admin" && <Tab eventKey="upload" title={
                                            <span>
                                                <i className='bx bx-upload'></i>
                                                Uploads
                                            </span>
                                        }>
                                            <RecentActivities type="upload" />
                                        </Tab>}
                                        {user_role === "super_admin" && <Tab eventKey="activities" title={
                                            <span>
                                                <i className='bx bx-pulse'></i>
                                                Activities
                                            </span>
                                        }>
                                            <RecentActivities type="activities" />
                                        </Tab>} */}
                                        </Tabs>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {/* <Row className='world-map-row  dashboard-subscription-container'>
                        <Col md={6} className='world-map-col'>
                            <div className='world-map-container'>
                                <WorldMapChart />
                            </div>
                        </Col>
                        <Col md={6} className='donut-chart-col'>
                            <DonutChart />
                        </Col>
                    </Row> */}
                    </div>}
                <Footer />
            </div>


            <Modal
                show={show}
                onHide={onHide}
                centered
                size="md"
                className="add-to-list-modal"
            >
                <Modal.Body>
                    <div className="text-center py-4 px-3">
                        <div
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                background: "#FFF4E5",
                                color: "#F59E0B",
                                fontSize: "42px"
                            }}
                        >
                            <i className="fa fa-exclamation-triangle"></i>
                        </div>

                        <h3 className="mt-4 fw-bold">
                            Plan Expired
                        </h3>

                        <p className="text-muted mb-1">
                            Your subscription has expired.
                        </p>

                        <p className="text-muted mb-4">
                            Please upgrade your plan to continue using this feature and access all premium services.
                        </p>

                        <div className="list-succes-btns d-flex justify-content-center gap-3">

                            <Button
                                variant="warning"
                                onClick={navigateToUpgrade}
                                className="px-4 fw-semibold"
                            >
                                <i className="fa fa-arrow-circle-up me-2"></i>
                                Upgrade Plan
                            </Button>

                            <Button
                                variant="outline-secondary"
                                onClick={closeModal}
                                className="px-4"
                            >
                                Close
                            </Button>

                        </div>

                    </div>

                </Modal.Body>
            </Modal>
        </div>

    );
};

export default Dashboard;
